export default defineNuxtPlugin((nuxtApp) => {
  if (!import.meta.client) return;

  console.log("[Logger Plugin] Initialized");

  const recentErrors = new Set<string>();

  const isDuplicateLog = (key: string) => {
    if (recentErrors.has(key)) return true;
    recentErrors.add(key);
    setTimeout(() => recentErrors.delete(key), 5000); // 5 saniye içinde aynı hata tekrar loglanmasın
    return false;
  };

  const sendLog = async (payload: {
    type: string;
    message: string;
    stack: string;
    severity?: "error" | "warn" | "info";
  }) => {
    const timestamp = new Date().toISOString();
    const url = window.location.href;
    const userAgent = navigator.userAgent;
    const key = `${payload.type}-${payload.message}`;

    if (isDuplicateLog(key)) return;

    const formattedMessage = `
[${timestamp}] [${payload.type}] [${payload.severity?.toUpperCase() ?? "INFO"}]
Message   : ${payload.message}
Page URL  : ${url}
UserAgent : ${userAgent}
Stack     :
${payload.stack}

------------------------------------------------------------
`;

    try {
      await $fetch("/api/log.client", {
        method: "POST",
        body: {
          log: formattedMessage,
        },
      });
    } catch (e) {
      console.warn("Logger Plugin: Failed to send log", e);
    }
  };

  // JS Runtime Error
  window.onerror = function (message, source, lineno, colno, error) {
    console.warn("[Logger Plugin] window.onerror triggered");
    sendLog({
      type: "client-error",
      severity: "error",
      message: message?.toString(),
      stack: error?.stack || `${source}:${lineno}:${colno}`,
    });
  };

  // Unhandled Promise Rejection
  window.onunhandledrejection = function (event) {
    console.warn("[Logger Plugin] onunhandledrejection triggered");
    sendLog({
      type: "promise-rejection",
      severity: "error",
      message: event.reason?.toString(),
      stack: event.reason?.stack || "",
    });
  };

  // Vue Component Error
  nuxtApp.vueApp.config.errorHandler = (err, instance, info) => {
    console.warn("[Logger Plugin] vue-error triggered");

    const componentName = instance?.$options?.name || "anonymous";
    const props = instance?.$props
      ? JSON.stringify(instance.$props, null, 2)
      : "N/A";

    sendLog({
      type: "vue-error",
      severity: "error",
      message: `${err.toString()} | Component: ${componentName} | Info: ${info}`,
      stack: err?.stack || `Props:\n${props}`,
    });
  };
});
